import {useContext, useEffect, useState} from "react";
import {InputTextCustom, SearchCustomFunc} from "../../components";
import {SetorApi, UserApi, BancoApi} from "../../apis";
import {FaBusinessTime, FaTimes} from "react-icons/fa";
import {LoadingContext, PageContext, ToastContext, UserContext} from "../../contexts";
import Logo from "../../assets/img/logo-h.png";
import {useNavigate} from "react-router";
import InputMask from "react-input-mask";

export const BancoHorasCreate = () => {
  const {user} = useContext(UserContext);
  const {pageInfo, setPageInfo} = useContext(PageContext);
  const {setLoading} = useContext(LoadingContext);
  const navigate = useNavigate();

  const visto = 0;

  const [setor, setSetor] = useState('');
  const [setorNome, setSetorNome] = useState('');
  const [listaSetor, setListaSetor] = useState([]);

  const [tipo, setTipo] = useState('Autorização');

  const [listaFuncionario, setListaFuncionario] = useState([]);

  const [titulo, setTitulo] = useState('');
  const [errorTitulo, setErrorTitulo] = useState(false);
  const [helperTitulo, setHelperTitulo] = useState('');

  const [count, setCount] = useState(0);
  const [preview, setPreview] = useState(false);

  const [linhas, setLinhas] = useState([]);
  const [linha1, setLinha1] = useState({funcionario: '', funcionarioNome: '', hora: '', data: '', matricula: ''});
  const [linha2, setLinha2] = useState({funcionario: '', funcionarioNome: '', hora: '', data: '', matricula: ''});
  const [linha3, setLinha3] = useState({funcionario: '', funcionarioNome: '', hora: '', data: '', matricula: ''});
  const [linha4, setLinha4] = useState({funcionario: '', funcionarioNome: '', hora: '', data: '', matricula: ''});
  const [linha5, setLinha5] = useState({funcionario: '', funcionarioNome: '', hora: '', data: '', matricula: ''});
  const [linha6, setLinha6] = useState({funcionario: '', funcionarioNome: '', hora: '', data: '', matricula: ''});
  const [linha7, setLinha7] = useState({funcionario: '', funcionarioNome: '', hora: '', data: '', matricula: ''});
  const [linha8, setLinha8] = useState({funcionario: '', funcionarioNome: '', hora: '', data: '', matricula: ''});
  const [linha9, setLinha9] = useState({funcionario: '', funcionarioNome: '', hora: '', data: '', matricula: ''});
  const [linha10, setLinha10] = useState({funcionario: '', funcionarioNome: '', hora: '', data: '', matricula: ''});
  const [linha11, setLinha11] = useState({funcionario: '', funcionarioNome: '', hora: '', data: '', matricula: ''});
  const [linha12, setLinha12] = useState({funcionario: '', funcionarioNome: '', hora: '', data: '', matricula: ''});
  const [linha13, setLinha13] = useState({funcionario: '', funcionarioNome: '', hora: '', data: '', matricula: ''});
  const [linha14, setLinha14] = useState({funcionario: '', funcionarioNome: '', hora: '', data: '', matricula: ''});
  const [linha15, setLinha15] = useState({funcionario: '', funcionarioNome: '', hora: '', data: '', matricula: ''});
  const [linha16, setLinha16] = useState({funcionario: '', funcionarioNome: '', hora: '', data: '', matricula: ''});
  const [linha17, setLinha17] = useState({funcionario: '', funcionarioNome: '', hora: '', data: '', matricula: ''});
  const [linha18, setLinha18] = useState({funcionario: '', funcionarioNome: '', hora: '', data: '', matricula: ''});
  const [linha19, setLinha19] = useState({funcionario: '', funcionarioNome: '', hora: '', data: '', matricula: ''});
  const [linha20, setLinha20] = useState({funcionario: '', funcionarioNome: '', hora: '', data: '', matricula: ''});
  const [linha21, setLinha21] = useState({funcionario: '', funcionarioNome: '', hora: '', data: '', matricula: ''});
  const [linha22, setLinha22] = useState({funcionario: '', funcionarioNome: '', hora: '', data: '', matricula: ''});
  const [linha23, setLinha23] = useState({funcionario: '', funcionarioNome: '', hora: '', data: '', matricula: ''});
  const [linha24, setLinha24] = useState({funcionario: '', funcionarioNome: '', hora: '', data: '', matricula: ''});
  const [linha25, setLinha25] = useState({funcionario: '', funcionarioNome: '', hora: '', data: '', matricula: ''});

  const data = new Date();
  const mes = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'];

  const toasts = useContext(ToastContext);
  const AddToast = (item) => {
    let tempArr = [...toasts.toast];
    tempArr.push(item);
    toasts.setToast({toast: tempArr, setToast: toasts.setToast});
  }

  const load = async () => {
    setLoading(true);
    try {
      let respostaSetor = await SetorApi.get();
      if (!respostaSetor.error) {
        setListaSetor(respostaSetor.data);
      } else {
        AddToast({texto: "Falha ao carregar setores!", tipo: "erro"});
      }
      setLoading(false);
    } catch (e) {
      AddToast({texto: e, tipo: "erro"});
      setLoading(false);
    }
    try {
      let respostaFuncionario = await UserApi.getFuncionarios(user.uuid);
      if (!respostaFuncionario.error) {
        let listaFunc = [];
        listaFunc.push({uuid: "", nome: "", matricula: ""});
        respostaFuncionario.data.forEach((item) => {
          listaFunc.push(item)
        });
        setListaFuncionario(listaFunc);
      } else {
        AddToast({texto: "Falha ao carregar funcionários!", tipo: "erro"});
      }
      setLoading(false);
    } catch (e) {
      AddToast({texto: e, tipo: "erro"});
      setLoading(false);
    }
  }
  useEffect(() => {
    if (listaSetor.length > 0) {
      setSetor(listaSetor[0].uuid);
      setSetorNome(listaSetor[0].titulo);
    }
  }, [listaSetor]);

  if (count < 1) {
    load();
    setPageInfo(
      {
        ...pageInfo,
        titulo: 'Banco de Horas',
        icone: <FaBusinessTime size={30}/>
      }
    );
    setCount(count + 1);
  }

  const send = async () => {
    setLoading(true);
    try {
      let respostaEnvio = await BancoApi.create(user.uuid, titulo, setor, tipo, linhas, visto);
      if (!respostaEnvio.error) {
        AddToast({texto: "Enviado!", tipo: "sucesso"});
        setLoading(false);
        setPreview(false);
        navigate(-1);
      } else {
        AddToast({texto: respostaEnvio.error, tipo: "erro"});
        setLoading(false);
        setPreview(false);
      }
    } catch (e) {
      AddToast({texto: e, tipo: "erro"});
      setLoading(false);
      setPreview(false);
    }
  }

  const validarCampos = () => {
    let linhasTemp = [];
    if (linha1.funcionario !== '' && linha1.hora !== '' && linha1.data !== '') {
      linhasTemp.push(linha1);
    }
    if (linha2.funcionario !== '' && linha2.hora !== '' && linha2.data !== '') {
      linhasTemp.push(linha2);
    }
    if (linha3.funcionario !== '' && linha3.hora !== '' && linha3.data !== '') {
      linhasTemp.push(linha3);
    }
    if (linha4.funcionario !== '' && linha4.hora !== '' && linha4.data !== '') {
      linhasTemp.push(linha4);
    }
    if (linha5.funcionario !== '' && linha5.hora !== '' && linha5.data !== '') {
      linhasTemp.push(linha5);
    }
    if (linha6.funcionario !== '' && linha6.hora !== '' && linha6.data !== '') {
      linhasTemp.push(linha6);
    }
    if (linha7.funcionario !== '' && linha7.hora !== '' && linha7.data !== '') {
      linhasTemp.push(linha7);
    }
    if (linha8.funcionario !== '' && linha8.hora !== '' && linha8.data !== '') {
      linhasTemp.push(linha8);
    }
    if (linha9.funcionario !== '' && linha9.hora !== '' && linha9.data !== '') {
      linhasTemp.push(linha9);
    }
    if (linha10.funcionario !== '' && linha10.hora !== '' && linha10.data !== '') {
      linhasTemp.push(linha10);
    }
    if (linha11.funcionario !== '' && linha11.hora !== '' && linha11.data !== '') {
      linhasTemp.push(linha11);
    }
    if (linha12.funcionario !== '' && linha12.hora !== '' && linha12.data !== '') {
      linhasTemp.push(linha12);
    }
    if (linha13.funcionario !== '' && linha13.hora !== '' && linha13.data !== '') {
      linhasTemp.push(linha13);
    }
    if (linha14.funcionario !== '' && linha14.hora !== '' && linha14.data !== '') {
      linhasTemp.push(linha14);
    }
    if (linha15.funcionario !== '' && linha15.hora !== '' && linha15.data !== '') {
      linhasTemp.push(linha15);
    }
    if (linha16.funcionario !== '' && linha16.hora !== '' && linha16.data !== '') {
      linhasTemp.push(linha16);
    }
    if (linha17.funcionario !== '' && linha17.hora !== '' && linha17.data !== '') {
      linhasTemp.push(linha17);
    }
    if (linha18.funcionario !== '' && linha18.hora !== '' && linha18.data !== '') {
      linhasTemp.push(linha18);
    }
    if (linha19.funcionario !== '' && linha19.hora !== '' && linha19.data !== '') {
      linhasTemp.push(linha19);
    }
    if (linha20.funcionario !== '' && linha20.hora !== '' && linha20.data !== '') {
      linhasTemp.push(linha20);
    }
    if (linha21.funcionario !== '' && linha21.hora !== '' && linha21.data !== '') {
      linhasTemp.push(linha21);
    }
    if (linha22.funcionario !== '' && linha22.hora !== '' && linha22.data !== '') {
      linhasTemp.push(linha22);
    }
    if (linha23.funcionario !== '' && linha23.hora !== '' && linha23.data !== '') {
      linhasTemp.push(linha23);
    }
    if (linha24.funcionario !== '' && linha24.hora !== '' && linha24.data !== '') {
      linhasTemp.push(linha24);
    }
    if (linha25.funcionario !== '' && linha25.hora !== '' && linha25.data !== '') {
      linhasTemp.push(linha25);
    }

    if (linhasTemp.length === 0) {
      AddToast({texto: "Nenhum registro identificado", tipo: "erro"});
      return false;
    } else {
      setLinhas(linhasTemp);
    }

    if (titulo === '') {
      setHelperTitulo("O campo não pode estar vazio");
      setErrorTitulo(true);
      return false;
    }

    if (setor === '') {
      AddToast({texto: "Setor não pode estar vazio", tipo: "erro"});
      return false;
    }

    return true;
  }

  const openPreview = () => {
    if (validarCampos()) {
      setPreview(true);
    }
  }


  return (
    <div className="form-ci">
      <div className="painel-itens">
        <h2 className="titulo" style={{marginBottom: "30px"}}>Adicionar Registro</h2>
        <InputTextCustom
          label="Título:"
          value={titulo}
          onChange={(t) => setTitulo(t.target.value)}
          helperText={helperTitulo}
          error={errorTitulo}
        />
        {listaSetor.length > 0 &&
          <div className="seletor">
            <label>Setor:</label>
            <select onChange={(e) => {
              setSetor(e.target.value);
              setSetorNome(e.target.selectedOptions[0].label);
            }}>
              {listaSetor.map((item) => (
                <option key={item.uuid} value={item.uuid}>{item.titulo}</option>
              ))}
            </select>
          </div>
        }

        <div className="seletor">
          <label>Tipo:</label>
          <select onChange={(e) => {
            setTipo(e.target.selectedOptions[0].label);
          }}>
            <option>Autorização</option>
            <option>Compensação</option>
          </select>
        </div>

        <table className={"tabela"}>
          <tr>
            <th>Matrícula</th>
            <th>Colaborador</th>
            <th>Horas</th>
            <th>Data</th>
          </tr>
          <tr>
            <td>
              {linha1.matricula}
            </td>
            <td>
              {listaFuncionario &&
                <SearchCustomFunc
                  selected={linha1.funcionario}
                  selectedName={linha1.funcionarioNome}
                  itens={listaFuncionario}
                  change={(f, n, m) => {
                    setLinha1({...linha1, funcionario: f, funcionarioNome: n, matricula: m})
                  }}
                />
              }
            </td>
            <td>
              <InputMask value={linha1.hora} onChange={(t) => {
                setLinha1({...linha1, hora: t.target.value})
              }} mask={"99:99"} maskChar={"_"}/>
            </td>
            <td>
              <input type={"text"} value={linha1.data} onChange={(t) => {
                setLinha1({...linha1, data: t.target.value})
              }}/>
            </td>
          </tr>

          <tr>
            <td>
              {linha2.matricula}
            </td>
            <td>
              {listaFuncionario &&
                <SearchCustomFunc
                  selected={linha2.funcionario}
                  selectedName={linha2.funcionarioNome}
                  itens={listaFuncionario}
                  change={(f, n, m) => {
                    setLinha2({...linha2, funcionario: f, funcionarioNome: n, matricula: m})
                  }}
                />
              }
            </td>
            <td>
              <InputMask value={linha2.hora} onChange={(t) => {
                setLinha2({...linha2, hora: t.target.value})
              }} mask={"99:99"} maskChar={"_"}/>
            </td>
            <td>
              <input type={"text"} value={linha2.data} onChange={(t) => {
                setLinha2({...linha2, data: t.target.value})
              }}/>
            </td>
          </tr>

          <tr>
            <td>
              {linha3.matricula}
            </td>
            <td>
              {listaFuncionario &&
                <SearchCustomFunc
                  selected={linha3.funcionario}
                  selectedName={linha3.funcionarioNome}
                  itens={listaFuncionario}
                  change={(f, n, m) => {
                    setLinha3({...linha3, funcionario: f, funcionarioNome: n, matricula: m})
                  }}
                />
              }
            </td>
            <td>
              <InputMask value={linha3.hora} onChange={(t) => {
                setLinha3({...linha3, hora: t.target.value})
              }} mask={"99:99"} maskChar={"_"} />
            </td>
            <td>
              <input type={"text"} value={linha3.data} onChange={(t) => {
                setLinha3({...linha3, data: t.target.value})
              }}/>
            </td>
          </tr>

          <tr>
            <td>
              {linha4.matricula}
            </td>
            <td>
              {listaFuncionario &&
                <SearchCustomFunc
                  selected={linha4.funcionario}
                  selectedName={linha4.funcionarioNome}
                  itens={listaFuncionario}
                  change={(f, n, m) => {
                    setLinha4({...linha4, funcionario: f, funcionarioNome: n, matricula: m})
                  }}
                />
              }
            </td>
            <td>
              <InputMask value={linha4.hora} onChange={(t) => {
                setLinha4({...linha4, hora: t.target.value})
              }} mask={"99:99"} maskChar={"_"} />
            </td>
            <td>
              <input type={"text"} value={linha4.data} onChange={(t) => {
                setLinha4({...linha4, data: t.target.value})
              }}/>
            </td>
          </tr>

          <tr>
            <td>
              {linha5.matricula}
            </td>
            <td>
              {listaFuncionario &&
                <SearchCustomFunc
                  selected={linha5.funcionario}
                  selectedName={linha5.funcionarioNome}
                  itens={listaFuncionario}
                  change={(f, n, m) => {
                    setLinha5({...linha5, funcionario: f, funcionarioNome: n, matricula: m})
                  }}
                />
              }
            </td>
            <td>
              <InputMask value={linha5.hora} onChange={(t) => {
                setLinha5({...linha5, hora: t.target.value})
              }} mask={"99:99"} maskChar={"_"} />
            </td>
            <td>
              <input type={"text"} value={linha5.data} onChange={(t) => {
                setLinha5({...linha5, data: t.target.value})
              }}/>
            </td>
          </tr>

          <tr>
            <td>
              {linha6.matricula}
            </td>
            <td>
              {listaFuncionario &&
                <SearchCustomFunc
                  selected={linha6.funcionario}
                  selectedName={linha6.funcionarioNome}
                  itens={listaFuncionario}
                  change={(f, n, m) => {
                    setLinha6({...linha6, funcionario: f, funcionarioNome: n, matricula: m})
                  }}
                />
              }
            </td>
            <td>
              <InputMask value={linha6.hora} onChange={(t) => {
                setLinha6({...linha6, hora: t.target.value})
              }} mask={"99:99"} maskChar={"_"} />
            </td>
            <td>
              <input type={"text"} value={linha6.data} onChange={(t) => {
                setLinha6({...linha6, data: t.target.value})
              }}/>
            </td>
          </tr>

          <tr>
            <td>
              {linha7.matricula}
            </td>
            <td>
              {listaFuncionario &&
                <SearchCustomFunc
                  selected={linha7.funcionario}
                  selectedName={linha7.funcionarioNome}
                  itens={listaFuncionario}
                  change={(f, n, m) => {
                    setLinha7({...linha7, funcionario: f, funcionarioNome: n, matricula: m})
                  }}
                />
              }
            </td>
            <td>
              <InputMask value={linha7.hora} onChange={(t) => {
                setLinha7({...linha7, hora: t.target.value})
              }} mask={"99:99"} maskChar={"_"} />
            </td>
            <td>
              <input type={"text"} value={linha7.data} onChange={(t) => {
                setLinha7({...linha7, data: t.target.value})
              }}/>
            </td>
          </tr>

          <tr>
            <td>
              {linha8.matricula}
            </td>
            <td>
              {listaFuncionario &&
                <SearchCustomFunc
                  selected={linha8.funcionario}
                  selectedName={linha8.funcionarioNome}
                  itens={listaFuncionario}
                  change={(f, n, m) => {
                    setLinha8({...linha8, funcionario: f, funcionarioNome: n, matricula: m})
                  }}
                />
              }
            </td>
            <td>
              <InputMask value={linha8.hora} onChange={(t) => {
                setLinha8({...linha8, hora: t.target.value})
              }} mask={"99:99"} maskChar={"_"} />
            </td>
            <td>
              <input type={"text"} value={linha8.data} onChange={(t) => {
                setLinha8({...linha8, data: t.target.value})
              }}/>
            </td>
          </tr>

          <tr>
            <td>
              {linha9.matricula}
            </td>
            <td>
              {listaFuncionario &&
                <SearchCustomFunc
                  selected={linha9.funcionario}
                  selectedName={linha9.funcionarioNome}
                  itens={listaFuncionario}
                  change={(f, n, m) => {
                    setLinha9({...linha9, funcionario: f, funcionarioNome: n, matricula: m})
                  }}
                />
              }
            </td>
            <td>
              <InputMask value={linha9.hora} onChange={(t) => {
                setLinha9({...linha9, hora: t.target.value})
              }} mask={"99:99"} maskChar={"_"} />
            </td>
            <td>
              <input type={"text"} value={linha9.data} onChange={(t) => {
                setLinha9({...linha9, data: t.target.value})
              }}/>
            </td>
          </tr>

          <tr>
            <td>
              {linha10.matricula}
            </td>
            <td>
              {listaFuncionario &&
                <SearchCustomFunc
                  selected={linha10.funcionario}
                  selectedName={linha10.funcionarioNome}
                  itens={listaFuncionario}
                  change={(f, n, m) => {
                    setLinha10({...linha10, funcionario: f, funcionarioNome: n, matricula: m})
                  }}
                />
              }
            </td>
            <td>
              <InputMask value={linha10.hora} onChange={(t) => {
                setLinha10({...linha10, hora: t.target.value})
              }} mask={"99:99"} maskChar={"_"} />
            </td>
            <td>
              <input type={"text"} value={linha10.data} onChange={(t) => {
                setLinha10({...linha10, data: t.target.value})
              }}/>
            </td>
          </tr>

          <tr>
            <td>
              {linha11.matricula}
            </td>
            <td>
              {listaFuncionario &&
                <SearchCustomFunc
                  selected={linha11.funcionario}
                  selectedName={linha11.funcionarioNome}
                  itens={listaFuncionario}
                  change={(f, n, m) => {
                    setLinha11({...linha11, funcionario: f, funcionarioNome: n, matricula: m})
                  }}
                />
              }
            </td>
            <td>
              <InputMask value={linha11.hora} onChange={(t) => {
                setLinha11({...linha11, hora: t.target.value})
              }} mask={"99:99"} maskChar={"_"} />
            </td>
            <td>
              <input type={"text"} value={linha11.data} onChange={(t) => {
                setLinha11({...linha11, data: t.target.value})
              }}/>
            </td>
          </tr>

          <tr>
            <td>
              {linha12.matricula}
            </td>
            <td>
              {listaFuncionario &&
                <SearchCustomFunc
                  selected={linha12.funcionario}
                  selectedName={linha12.funcionarioNome}
                  itens={listaFuncionario}
                  change={(f, n, m) => {
                    setLinha12({...linha12, funcionario: f, funcionarioNome: n, matricula: m})
                  }}
                />
              }
            </td>
            <td>
              <InputMask value={linha12.hora} onChange={(t) => {
                setLinha12({...linha12, hora: t.target.value})
              }} mask={"99:99"} maskChar={"_"} />
            </td>
            <td>
              <input type={"text"} value={linha12.data} onChange={(t) => {
                setLinha12({...linha12, data: t.target.value})
              }}/>
            </td>
          </tr>

          <tr>
            <td>
              {linha13.matricula}
            </td>
            <td>
              {listaFuncionario &&
                <SearchCustomFunc
                  selected={linha13.funcionario}
                  selectedName={linha13.funcionarioNome}
                  itens={listaFuncionario}
                  change={(f, n, m) => {
                    setLinha13({...linha13, funcionario: f, funcionarioNome: n, matricula: m})
                  }}
                />
              }
            </td>
            <td>
              <InputMask value={linha13.hora} onChange={(t) => {
                setLinha13({...linha13, hora: t.target.value})
              }} mask={"99:99"} maskChar={"_"} />
            </td>
            <td>
              <input type={"text"} value={linha13.data} onChange={(t) => {
                setLinha13({...linha13, data: t.target.value})
              }}/>
            </td>
          </tr>

          <tr>
            <td>
              {linha14.matricula}
            </td>
            <td>
              {listaFuncionario &&
                <SearchCustomFunc
                  selected={linha14.funcionario}
                  selectedName={linha14.funcionarioNome}
                  itens={listaFuncionario}
                  change={(f, n, m) => {
                    setLinha14({...linha14, funcionario: f, funcionarioNome: n, matricula: m})
                  }}
                />
              }
            </td>
            <td>
              <InputMask value={linha14.hora} onChange={(t) => {
                setLinha14({...linha14, hora: t.target.value})
              }} mask={"99:99"} maskChar={"_"} />
            </td>
            <td>
              <input type={"text"} value={linha14.data} onChange={(t) => {
                setLinha14({...linha14, data: t.target.value})
              }}/>
            </td>
          </tr>

          <tr>
            <td>
              {linha15.matricula}
            </td>
            <td>
              {listaFuncionario &&
                <SearchCustomFunc
                  selected={linha15.funcionario}
                  selectedName={linha15.funcionarioNome}
                  itens={listaFuncionario}
                  change={(f, n, m) => {
                    setLinha15({...linha15, funcionario: f, funcionarioNome: n, matricula: m})
                  }}
                />
              }
            </td>
            <td>
              <InputMask value={linha15.hora} onChange={(t) => {
                setLinha15({...linha15, hora: t.target.value})
              }} mask={"99:99"} maskChar={"_"} />
            </td>
            <td>
              <input type={"text"} value={linha15.data} onChange={(t) => {
                setLinha15({...linha15, data: t.target.value})
              }}/>
            </td>
          </tr>

          <tr>
            <td>
              {linha16.matricula}
            </td>
            <td>
              {listaFuncionario &&
                <SearchCustomFunc
                  selected={linha16.funcionario}
                  selectedName={linha16.funcionarioNome}
                  itens={listaFuncionario}
                  change={(f, n, m) => {
                    setLinha16({...linha16, funcionario: f, funcionarioNome: n, matricula: m})
                  }}
                />
              }
            </td>
            <td>
              <InputMask value={linha16.hora} onChange={(t) => {
                setLinha16({...linha16, hora: t.target.value})
              }} mask={"99:99"} maskChar={"_"} />
            </td>
            <td>
              <input type={"text"} value={linha16.data} onChange={(t) => {
                setLinha16({...linha16, data: t.target.value})
              }}/>
            </td>
          </tr>

          <tr>
            <td>
              {linha17.matricula}
            </td>
            <td>
              {listaFuncionario &&
                <SearchCustomFunc
                  selected={linha17.funcionario}
                  selectedName={linha17.funcionarioNome}
                  itens={listaFuncionario}
                  change={(f, n, m) => {
                    setLinha17({...linha17, funcionario: f, funcionarioNome: n, matricula: m})
                  }}
                />
              }
            </td>
            <td>
              <InputMask value={linha17.hora} onChange={(t) => {
                setLinha17({...linha17, hora: t.target.value})
              }} mask={"99:99"} maskChar={"_"} />
            </td>
            <td>
              <input type={"text"} value={linha17.data} onChange={(t) => {
                setLinha17({...linha17, data: t.target.value})
              }}/>
            </td>
          </tr>

          <tr>
            <td>
              {linha18.matricula}
            </td>
            <td>
              {listaFuncionario &&
                <SearchCustomFunc
                  selected={linha18.funcionario}
                  selectedName={linha18.funcionarioNome}
                  itens={listaFuncionario}
                  change={(f, n, m) => {
                    setLinha18({...linha18, funcionario: f, funcionarioNome: n, matricula: m})
                  }}
                />
              }
            </td>
            <td>
              <InputMask value={linha18.hora} onChange={(t) => {
                setLinha18({...linha18, hora: t.target.value})
              }} mask={"99:99"} maskChar={"_"} />
            </td>
            <td>
              <input type={"text"} value={linha18.data} onChange={(t) => {
                setLinha18({...linha18, data: t.target.value})
              }}/>
            </td>
          </tr>

          <tr>
            <td>
              {linha19.matricula}
            </td>
            <td>
              {listaFuncionario &&
                <SearchCustomFunc
                  selected={linha19.funcionario}
                  selectedName={linha19.funcionarioNome}
                  itens={listaFuncionario}
                  change={(f, n, m) => {
                    setLinha19({...linha19, funcionario: f, funcionarioNome: n, matricula: m})
                  }}
                />
              }
            </td>
            <td>
              <InputMask value={linha19.hora} onChange={(t) => {
                setLinha19({...linha19, hora: t.target.value})
              }} mask={"99:99"} maskChar={"_"} />
            </td>
            <td>
              <input type={"text"} value={linha19.data} onChange={(t) => {
                setLinha19({...linha19, data: t.target.value})
              }}/>
            </td>
          </tr>

          <tr>
            <td>
              {linha20.matricula}
            </td>
            <td>
              {listaFuncionario &&
                <SearchCustomFunc
                  selected={linha20.funcionario}
                  selectedName={linha20.funcionarioNome}
                  itens={listaFuncionario}
                  change={(f, n, m) => {
                    setLinha20({...linha20, funcionario: f, funcionarioNome: n, matricula: m})
                  }}
                />
              }
            </td>
            <td>
              <InputMask value={linha20.hora} onChange={(t) => {
                setLinha20({...linha20, hora: t.target.value})
              }} mask={"99:99"} maskChar={"_"} />
            </td>
            <td>
              <input type={"text"} value={linha20.data} onChange={(t) => {
                setLinha20({...linha20, data: t.target.value})
              }}/>
            </td>
          </tr>

          <tr>
            <td>
              {linha21.matricula}
            </td>
            <td>
              {listaFuncionario &&
                <SearchCustomFunc
                  selected={linha21.funcionario}
                  selectedName={linha21.funcionarioNome}
                  itens={listaFuncionario}
                  change={(f, n, m) => {
                    setLinha21({...linha21, funcionario: f, funcionarioNome: n, matricula: m})
                  }}
                />
              }
            </td>
            <td>
              <InputMask value={linha21.hora} onChange={(t) => {
                setLinha21({...linha21, hora: t.target.value})
              }} mask={"99:99"} maskChar={"_"} />
            </td>
            <td>
              <input type={"text"} value={linha21.data} onChange={(t) => {
                setLinha21({...linha21, data: t.target.value})
              }}/>
            </td>
          </tr>

          <tr>
            <td>
              {linha22.matricula}
            </td>
            <td>
              {listaFuncionario &&
                <SearchCustomFunc
                  selected={linha22.funcionario}
                  selectedName={linha22.funcionarioNome}
                  itens={listaFuncionario}
                  change={(f, n, m) => {
                    setLinha22({...linha22, funcionario: f, funcionarioNome: n, matricula: m})
                  }}
                />
              }
            </td>
            <td>
              <InputMask value={linha22.hora} onChange={(t) => {
                setLinha22({...linha22, hora: t.target.value})
              }} mask={"99:99"} maskChar={"_"} />
            </td>
            <td>
              <input type={"text"} value={linha22.data} onChange={(t) => {
                setLinha22({...linha22, data: t.target.value})
              }}/>
            </td>
          </tr>

          <tr>
            <td>
              {linha23.matricula}
            </td>
            <td>
              {listaFuncionario &&
                <SearchCustomFunc
                  selected={linha23.funcionario}
                  selectedName={linha23.funcionarioNome}
                  itens={listaFuncionario}
                  change={(f, n, m) => {
                    setLinha23({...linha23, funcionario: f, funcionarioNome: n, matricula: m})
                  }}
                />
              }
            </td>
            <td>
              <InputMask value={linha23.hora} onChange={(t) => {
                setLinha23({...linha23, hora: t.target.value})
              }} mask={"99:99"} maskChar={"_"} />
            </td>
            <td>
              <input type={"text"} value={linha23.data} onChange={(t) => {
                setLinha23({...linha23, data: t.target.value})
              }}/>
            </td>
          </tr>

          <tr>
            <td>
              {linha24.matricula}
            </td>
            <td>
              {listaFuncionario &&
                <SearchCustomFunc
                  selected={linha24.funcionario}
                  selectedName={linha24.funcionarioNome}
                  itens={listaFuncionario}
                  change={(f, n, m) => {
                    setLinha24({...linha24, funcionario: f, funcionarioNome: n, matricula: m})
                  }}
                />
              }
            </td>
            <td>
              <InputMask value={linha24.hora} onChange={(t) => {
                setLinha24({...linha24, hora: t.target.value})
              }} mask={"99:99"} maskChar={"_"} />
            </td>
            <td>
              <input type={"text"} value={linha24.data} onChange={(t) => {
                setLinha24({...linha24, data: t.target.value})
              }}/>
            </td>
          </tr>

          <tr>
            <td>
              {linha25.matricula}
            </td>
            <td>
              {listaFuncionario &&
                <SearchCustomFunc
                  selected={linha25.funcionario}
                  selectedName={linha25.funcionarioNome}
                  itens={listaFuncionario}
                  change={(f, n, m) => {
                    setLinha25({...linha25, funcionario: f, funcionarioNome: n, matricula: m})
                  }}
                />
              }
            </td>
            <td>
              <InputMask value={linha25.hora} onChange={(t) => {
                setLinha25({...linha25, hora: t.target.value})
              }} mask={"99:99"} maskChar={"_"} />
            </td>
            <td>
              <input type={"text"} value={linha25.data} onChange={(t) => {
                setLinha25({...linha25, data: t.target.value})
              }}/>
            </td>
          </tr>
        </table>

        <div className="d-flex justify-end">
          <div className="btn btn-cancelar" onClick={() => navigate(-1)}>
            Cancelar
          </div>
          <div className="btn btn-enviar" onClick={() => openPreview()}>
            Cadastrar
          </div>
        </div>

      </div>
      {preview &&
        <div className="tela-modal-preview">
          <div className="modal">
            <div className="modal-arquivo-cabecalho">
              <div className="titulo">
                <FaBusinessTime size={30}/>
                <span>Pré-visualização</span>
              </div>
              <div className="btn-close-modal" onClick={() => {
                setPreview(false)
              }}>
                Fechar(<FaTimes/>)
              </div>
            </div>
            <div className="documento">
              <img className="logo-documento" src={Logo} alt="Logo Nunes Peixoto"/>
              <span className="titulo" style={{textTransform:"uppercase"}}>{tipo} Para Banco de Horas</span>
              <span className="linha">Setor: <span className="valor">{setorNome}</span></span>

              <table className={"tabela"}>
                <tr>
                  <th>Matrícula</th>
                  <th>Colaborador</th>
                  <th>Horas</th>
                  <th>Data</th>
                </tr>
                {linhas.length > 0 && linhas.map((linha, index) => (
                  <tr key={index}>
                    <td>{linha.matricula}</td>
                    <td>{linha.funcionarioNome}</td>
                    <td>{linha.hora}</td>
                    <td>{linha.data}</td>
                  </tr>
                ))}
              </table>

              <span className="linha">Itabaiana, <span className="valor">{data.getDate()}</span> de <span
                className="valor">{mes[data.getMonth()]}</span> de <span
                className="valor">{data.getFullYear()}</span></span>
              <span className="centro"><span className="valor">{user.nome}</span></span>
              <span className="centro">Assinatura do solicitante</span>
            </div>
            <div className="btn btn-enviar" onClick={send}>
              Cadastrar
            </div>
          </div>
        </div>
      }
    </div>
  );
}